import { render, staticRenderFns } from "./PublicationProjectPage.vue?vue&type=template&id=fe708f5c&"
import script from "./PublicationProjectPage.vue?vue&type=script&lang=js&"
export * from "./PublicationProjectPage.vue?vue&type=script&lang=js&"
import style0 from "./PublicationProjectPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports